/**
 * Active Floor - Handles functionality for active floor.
 */

import { HandleFloorDescription } from './FloorDescriptionManager'
import { activateIndicatorFromFloor } from './IndicatorManager'
import { handleFloorExpand } from './StackedImageManager'

/**
 * Triggers necessary functions on floor click.
 *
 * @function HandleActiveFloor
 * @returns {void} Does not return a value.
 */
const HandleActiveFloor = () => {
  const floors = document.querySelectorAll('.js-floor')

  if (floors.length) {
    floors.forEach(floor => {
      floor.addEventListener("click", () => {
        const floorID = floor.dataset.floorId

        HandleFloorDescription( floorID )

        activateIndicatorFromFloor( floorID )

        handleFloorExpand( floorID )

      })
    })
  } else {
    return
  }
}

export default HandleActiveFloor;
